import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { getSearchableRoutes, RouteSearchInfo } from '../../app-routing.module';
import { DoctorComponent } from './doctor.component';
import { MakeBookingComponent } from './pages/make-booking/make-booking.component';
import { PracticeBookingComponent } from './pages/practice-booking/practice-booking.component';

const routes: Routes = [
  {
    path: '',
    component: DoctorComponent,
    data: {
      title: 'Doctors',
      search_info: {
        keywords: ['search', 'doctor', 'book', 'appointment', 'consultation', 'closest', 'nearest', 'telemed', 'call'],
        items: [
          { phrase: 'Find a doctor', icon: 'magnify' },
          { phrase: 'Find the nearest doctor', icon: 'map-marker' },
          { phrase: 'Make a booking', icon: 'calendar' },
          { phrase: 'Make a telemed booking', icon: 'video' },
        ],
      } as RouteSearchInfo,
    },
  },
  {
    path: 'make-booking',
    component: MakeBookingComponent,
    data: { title: 'Book Online' },
  },
  {
    path: 'practice/:identifier',
    component: DoctorComponent,
    data: { title: 'Practice Page' },
  },
  {
    path: 'diary/:identifier',
    component: MakeBookingComponent,
    data: { title: 'Book Online' },
  },
  {
    path: 'practice/:identifier/first-timeslot',
    component: PracticeBookingComponent,
    data: { title: 'First Available Timeslot' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DoctorRoutingModule {}

export const SEARCHABLE_ROUTES = getSearchableRoutes(routes, '/doctors');
